// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "tinymce" + "." + "f80b8a37" + ".js";
};